import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';

import { pageErrorPng } from '../../assets/images';
import { Background } from '../../stories/Background';
import { Button } from '../../stories/Button';
import { Header } from '../../stories/Header';

interface ErrorPageProps {
  data?: {
    errorCode?: string;
    errorMessage?: string;
    serviceTeamUrl?: string;
    helpCenterUrl?: string;
    needReload?: boolean;
  };
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ data }) => {
  const __ = useTranslation().t;

  return (
    <>
      <Header type="logo-only" />
      <Background>
        <div className="oejr-utility-page">
          <Container>
            <Row className="justify-content-center align-items-center">
              <Col sm={12} md={6} className="text-center">
                <img src={pageErrorPng} alt="Error" className="oejr-utility-page-image" />
              </Col>
              <Col sm={12} md={6}>
                <div className="oejr-utility-page-text-container">
                  <h1 className="oejr-utility-page-header">{__('somethingWentWrong')}</h1>
                  <p className="oejr-utility-page-description">{__('teamWorkingOnIssue')}</p>
                  <p className="oejr-utility-page-description">
                    <Trans
                      alt={__('contactServicesTeamIssuePersists')}
                      i18nKey="contactServicesTeamIssuePersists"
                    >
                      If this issue persists, you can get in touch with our{' '}
                      <a href={data?.serviceTeamUrl}>Services Team</a> or visit the{' '}
                      <a href={data?.helpCenterUrl}>help center</a>.
                    </Trans>
                  </p>

                  <p className="oejr-utility-page-error-code">
                    {__('errorCode', { errorCode: data?.errorCode ?? '500' })}
                  </p>
                </div>
                <div className="responsive-buttons">
                  <Button label={__('goBack')} onClick={() => window.history.back()} />
                  {data?.needReload && (
                    <Button label={__('reload')} onClick={() => window.location.reload()} />
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Background>
    </>
  );
};
